import 'Styles/sections/recommendation-reels.scss';
import { initRecommendationReels } from '../recommendations';

console.log('[RecommendationReels] Bundle loaded, readyState:', document.readyState);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('[RecommendationReels] DOMContentLoaded fired — initializing');
    initRecommendationReels();
  });
} else {
  console.log('[RecommendationReels] DOM already ready — initializing immediately');
  initRecommendationReels();
}
